export default __webpack_public_path__ + "static/media/screen_google_drive_04.8df9f9e0.png";